import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { connect } from 'react-redux';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { vehicleActions } from '../../../actions/vehicleActions';

const ReasonModal = props => {
  const { handleReasonClose, adminVehicles } = props;

  return (
    <Dialog
      open={adminVehicles.showReasonModal}
      onClose={handleReasonClose}
      aria-labelledby="form-dialog-title"
    >
      <Toolbar className="text-center">
        <Typography variant="title" color="inherit" className="flex">
          Информация о заявке
        </Typography>
        <IconButton color="inherit" onClick={handleReasonClose}>
          <CloseIcon className="blue" />
        </IconButton>
      </Toolbar>

      <DialogContent className="dialog text-center">
        <span>
          Причина отклонения: {adminVehicles.currentItem && adminVehicles.currentItem.note}
        </span>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = state => {
  const { adminVehicles } = state;
  return {
    adminVehicles
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    handleReasonClose: () => {
      dispatch(vehicleActions.closeReasonModal());
    }
  };
};

const connectedReasonModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReasonModal);
export { connectedReasonModal as ReasonModal };
